export function getHttpErrorMessage(error: unknown, fallback: string): string {
  const payload = (error as { error?: unknown })?.error;

  if (typeof payload === 'string' && payload.trim()) {
    return payload.trim();
  }

  if (payload && typeof payload === 'object') {
    const source = payload as Record<string, unknown>;
    const candidates = [
      source['message'],
      source['error'],
      source['detail'],
      source['title'],
    ];
    const message = candidates.find((value) => typeof value === 'string' && value.trim());

    if (typeof message === 'string') {
      return message.trim();
    }
  }

  const directMessage = (error as { message?: unknown })?.message;
  if (typeof directMessage === 'string' && directMessage.trim()) {
    return directMessage.trim();
  }

  return fallback;
}
